import { AccidentResponsibility } from "types/DigitalJourneySession";

import client from "./client";

export type ResponsibilityResponse = {
  responsibility: AccidentResponsibility;
};

export const getAccidentResponsibility = (
  phVehicleCircumstance: string,
  otherVehicleCircumstance: string
): Promise<ResponsibilityResponse> =>
  client
    .get(
      `/session/digitalJourney/responsibility?circumstanceVehicleA=${phVehicleCircumstance}&circumstanceVehicleB=${otherVehicleCircumstance}`
    )
    .then(({ data }) => data);
